import React, {useEffect, useState} from 'react';
import Box from "@mui/material/Box";
import clsx from "clsx";
import css from './LocalNews.module.css';
import Typography from "@mui/material/Typography";
import parse from 'html-react-parser';
import LocalNewsApi, {GoodArticle} from "./LocalNews.api";


const LocalNews = () => {

    const [goodArticle, setGoodArticle] = useState<GoodArticle | null>(null);


    useEffect(() => {
        const fetchArticles = async () => {
            const blogArticleApi = new LocalNewsApi('');

            try {
                const response = await blogArticleApi.article();
                if (response) {
                    setGoodArticle(response);
                }
            } catch (error) {
                console.error("Błąd podczas pobierania artykułów:", error);
            }
        };

        fetchArticles();
    }, [])


    return (

        goodArticle && (

            <Box className={clsx(css.localNews, 'apla')}>

                <Box className={clsx(css.article)}>

                    <Typography className={clsx(css.title)} variant="h4">
                        Wiadomości lokalne
                        <Typography variant="h6">
                            {goodArticle.shortDescription}
                        </Typography>
                    </Typography>

                    <Box className={clsx(css.main)}>
                        <Box className={clsx(css.rightColumn)}>
                            <img src={goodArticle.image}/>

                        </Box>

                        <Box className={clsx(css.content)}>
                            {parse(goodArticle.description)}
                        </Box>
                    </Box>



                </Box>

            </Box>
        )
    );
};

export default LocalNews